import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import * as React from "react";
import { useSelector } from "react-redux";
import classes from "./Spinner.module.css";

const Spinner = () => {
  const isShowLoadingSpinnerSelector = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );

  return (
    <div>
      <Backdrop
        className={classes.spinner}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isShowLoadingSpinnerSelector}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Spinner;
